import HBButton from "@/components/HBButton";
import HBIcon from "@/components/HBIcon";
import Image from "@/components/Image";
import { Violation } from "@/components/Violation";
import { useIsViolationAb } from "@/components/Violation/useIsViolationAb";
import { PIN_PRIVATE_STATUS } from "@/constants/pin";
import imageUrl from "@/utils/imageUrl";
import classNames from "classnames";
import { Else, If, Then, When } from "react-if";
import styles from "./index.module.less";

const iconMap = {
  time: "最近画板",
  search: "",
};

interface IProps {
  board: (IBoardInfo & { _icon?: string }) | null;
  cover?: IPinFile & { is_private?: number };
  index?: number;
  activeIndex?: number;
  onSelect?: (boardId: number) => void;
}
export default function BoardItem({
  board,
  cover,
  index,
  activeIndex,
  onSelect,
}: IProps) {
  const violationAb = useIsViolationAb();

  return (
    <>
      {board?._icon && (
        <div className={styles.splitText}>
          {iconMap[board._icon] || board._icon}{" "}
        </div>
      )}
      <div
        className={classNames([
          styles.item,
          activeIndex === index ? styles.active : null,
        ])}
        onClick={() => onSelect(board?.board_id)}
        data-index={index}
      >
        <div className={styles.content}>
          <div className={styles.left}>
            <div className={styles.img}>
              <If condition={!!cover}>
                <Then>
                  {cover?.is_private === PIN_PRIVATE_STATUS.VIOLATION &&
                  violationAb.new ? (
                    <Violation hideText iconSize={14} />
                  ) : (
                    <Image
                      src={imageUrl(cover, { width: 32 })}
                      alt={board?.title}
                    />
                  )}
                </Then>
                <Else>
                  <div className={styles.cover}>
                    <HBIcon type="ic_logo" />
                  </div>
                </Else>
              </If>
            </div>
            <div className={styles.name}>
              {board ? board?.title : "待归类采集"}
            </div>
            <When
              condition={
                board && board?.is_private !== 0 && board?.is_private !== 1
              }
            >
              <Image
                className={styles.private}
                src="https://grocery-cdn.huaban.com/file/18b716a018d811f0a59ecb9f4a74cfb9.svg"
                alt="私有画板"
                width={16}
                height={16}
              />
            </When>
          </div>
        </div>
        <div className={styles.operation}>
          <HBButton
            type="primary"
            data-board-id={board?.board_id}
            data-gd-click="button_click"
            data-button-name="采集"
            size="small"
          >
            采集
          </HBButton>
        </div>
      </div>
    </>
  );
}
